import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map } from 'immutable';

import { BrowseCheckbox } from './BrowseCheckbox';
import { BrowseControlContent } from './BrowseControlContent';
import { Tag } from './Tag';

/**
 * Read-only summary of the Director Dashboard drill-down context (date range, metric,
 * module and dealmakers) attached to a Browse → Targets search restored from a share link.
 *
 * @param props {Object}.
 * @param props.info {Immutable.Map} Filter state: { checked, reportType, reportTypeLabel, data }.
 * @param props.onChange {Function} Handle checkbox toggle.
 */
const DirectorDashboardFilterComponent = ({ info, onChange }) => {
  const filter = Map({
    name: 'directorDashboard',
    label: `Director Dashboard: ${info.get('reportTypeLabel')} Report`,
  });

  const data = info.get('data', Map());
  const rawUsers = data.get('users');
  const users = List.isList(rawUsers) ? rawUsers : List();

  const tagCompletedBy = users
    .filter(tag => tag)
    .map((tag, i) => <Tag key={tag.get('id')} index={i} value={tag.get('userName')} disableStatusChange />);

  return (
    <BrowseCheckbox filter={filter} info={info} onChange={onChange}>
      <BrowseControlContent variant="activity">
        <div className="form-inline">
          <div className="form-group form-group--input">
            <label>From</label>
            <input className="form-control" type="text" value={data.get('dateFrom') ?? ''} readOnly />
          </div>
          <div className="form-group form-group--input mt5">
            <label>To</label>
            <input className="form-control" type="text" value={data.get('dateTo') ?? ''} readOnly />
          </div>
        </div>

        <div className="form-group mt5">
          <label className="text-capitalize">{data.get('metricGroup')}</label>
          <input className="form-control" type="text" value={data.get('metricLabel')} readOnly />
        </div>

        <div className="form-group mt5">
          <label>Module</label>
          <input className="form-control" type="text" value={data.getIn(['module', 'userName']) ?? ''} readOnly />
        </div>

        <div className="form-group mt5">
          <label>Primary Dealmaker</label>
          <input
            className="form-control"
            type="text"
            value={data.getIn(['primaryDealmaker', 'userName']) ?? ''}
            readOnly
          />
        </div>

        <div className="form-group mt5">
          <label>Secondary Dealmaker</label>
          <input
            className="form-control"
            type="text"
            value={data.getIn(['secondaryDealmaker', 'userName']) ?? ''}
            readOnly
          />
        </div>

        {users.size > 0 && (
          <div className="form-group mt5">
            <label>Completed by</label>
            {tagCompletedBy}
          </div>
        )}
      </BrowseControlContent>
    </BrowseCheckbox>
  );
};

DirectorDashboardFilterComponent.propTypes = {
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

/** Director Dashboard filter component. */
export const DirectorDashboardFilter = memo(DirectorDashboardFilterComponent);
